/**
 * Product card interactions — color swatches, size picker, add to cart.
 */
(function () {
  function findCardImage(card) {
    return card.querySelector('[data-aaf-card-img], .aaf-card__img, .aaf-card__frame img');
  }

  function getOptionPositions(card) {
    return {
      color: parseInt(card.dataset.colorOption || '0', 10),
      size: parseInt(card.dataset.sizeOption || '0', 10),
    };
  }

  function getOptionValue(variant, position) {
    if (position === 1) return variant.option1;
    if (position === 2) return variant.option2;
    if (position === 3) return variant.option3;
    return null;
  }

  function getVariants(card) {
    var script = card.querySelector('[data-aaf-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function getSelectedColor(card) {
    var swatch = card.querySelector('[data-aaf-swatch].is-active');
    if (swatch) return swatch.getAttribute('aria-label');
    return card.dataset.defaultColor || null;
  }

  function getSelectedSize(card) {
    var btn = card.querySelector('[data-aaf-size].is-active');
    return btn ? btn.getAttribute('data-aaf-size') : null;
  }

  function findVariant(card, variants, color, size) {
    var pos = getOptionPositions(card);

    return variants.find(function (variant) {
      if (pos.color && color && getOptionValue(variant, pos.color) !== color) return false;
      if (pos.size && size && getOptionValue(variant, pos.size) !== size) return false;
      if (pos.size && !size) return false;
      return true;
    });
  }

  function setAtcState(card, variant) {
    var input = card.querySelector('[data-aaf-variant-id]');
    var button = card.querySelector('[data-aaf-atc]');
    var label = card.querySelector('[data-aaf-atc-label]');
    var pos = getOptionPositions(card);

    if (!input || !button || !label) return;

    if (variant && variant.available) {
      input.value = variant.id;
      input.disabled = false;
      button.disabled = false;
      label.textContent = 'Cart';
      return;
    }

    if (variant && !variant.available) {
      input.value = variant.id;
      input.disabled = true;
      button.disabled = true;
      label.textContent = 'Sold out';
      return;
    }

    input.value = '';
    input.disabled = true;
    button.disabled = true;
    label.textContent = 'Cart';
  }

  function updateSizeAvailability(card, variants, color) {
    var pos = getOptionPositions(card);
    if (!pos.size) return;

    card.querySelectorAll('[data-aaf-size]').forEach(function (btn) {
      var size = btn.getAttribute('data-aaf-size');
      var match = variants.find(function (variant) {
        if (pos.color && color && getOptionValue(variant, pos.color) !== color) return false;
        return getOptionValue(variant, pos.size) === size;
      });
      var available = !!(match && match.available);

      btn.disabled = !available;
      btn.classList.toggle('is-unavailable', !available);

      if (!available && btn.classList.contains('is-active')) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function updateVariant(card) {
    var variants = getVariants(card);
    if (!variants.length) return;

    var pos = getOptionPositions(card);
    var color = getSelectedColor(card);
    var size = getSelectedSize(card);
    var variant;

    if (pos.size) {
      variant = size ? findVariant(card, variants, color, size) : null;
    } else if (pos.color && color) {
      variant =
        variants.find(function (entry) {
          return getOptionValue(entry, pos.color) === color && entry.available;
        }) ||
        variants.find(function (entry) {
          return getOptionValue(entry, pos.color) === color;
        });
    } else {
      variant =
        variants.find(function (entry) {
          return entry.available;
        }) || variants[0];
    }

    updateSizeAvailability(card, variants, color);
    setAtcState(card, variant);
  }

  function onSwatchActivate(swatch) {
    var card = swatch.closest('.aaf-card');
    if (!card) return;

    var img = findCardImage(card);
    var url = swatch.getAttribute('data-image');
    if (img && url) {
      img.src = url;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    }

    card.querySelectorAll('[data-aaf-swatch]').forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-active');
    swatch.setAttribute('aria-pressed', 'true');

    card.querySelectorAll('[data-aaf-size].is-active').forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });

    updateVariant(card);
  }

  function onSwatchClick(event) {
    var swatch = event.target.closest('[data-aaf-swatch]');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();
    onSwatchActivate(swatch);
  }

  function onSizeClick(event) {
    var btn = event.target.closest('[data-aaf-size]');
    if (!btn || btn.disabled) return;

    var card = btn.closest('.aaf-card');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    card.querySelectorAll('[data-aaf-size]').forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');

    updateVariant(card);
  }

  function initCards() {
    document.querySelectorAll('.aaf-card').forEach(function (card) {
      if (card.querySelector('[data-aaf-card-shop]')) updateVariant(card);
    });
  }

  document.addEventListener('click', onSwatchClick, true);
  document.addEventListener('click', onSizeClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }
})();